import {useState} from 'react';
import useMessages from 'hooks/useMessages.hook';
import TOAST from 'consts/toast.consts';
import NeoButtonMain from 'design/design_components/neo/button/NeoButtonMain.base';
import LoadingDialog from 'components/LoadingDialog.component';
import ConsumptionService from 'services/consumption.service';
import conversationsUtil from 'utils/conversations.util';
import csvUtil from 'utils/csv.util';

export default function MessagesDetailDownloadButton(props) {
  const messages = useMessages();
  const [showDownloadingDialog, setShowDownloadingDialog] = useState(false);

  const handleDownloadButtonClick = async () => {
    const linesId = props.linesId;
    const fromDateString = props.period?.from;
    const toDateString = props.period?.to;
    if(linesId !== undefined && fromDateString !== undefined && toDateString !== undefined) {
      setShowDownloadingDialog(true);
      const response = await ConsumptionService.getCompanyConsumptionDetailFile(linesId, fromDateString, toDateString);
      if(response.success) {
        const downloadInstance = document.createElement('a');
        downloadInstance.href = response.payload.urlDownload;
        downloadInstance.target = '_blank';
        downloadInstance.click();
        messages.showToast(TOAST.SEVERITY.SUCCESS, 'Operación exitosa', 'Se descargó el archivo de detalle de consumo.');
      }
      else {
        messages.showToast(TOAST.SEVERITY.ERROR, 'Algo salió mal', 'No se pudo descargar el archivo de detalle de consumo, inténtalo de nuevo.');
      }
      setShowDownloadingDialog(false);
    }
  }

  return (
    <>
      <NeoButtonMain
        icon='pi pi-download'
        label='Reporte de consumo'
        disabled={props.loading}
        onClick={handleDownloadButtonClick}
      />
      {
        <LoadingDialog
          visible={showDownloadingDialog}
          message='Generando archivo (.csv)'
        />
      }
    </>
  );
}